<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
	isUpdatePasswordModalOpen: {
		type: Boolean,
		required: true,
	},
	passwordUpdated: {
		type: Function,
		required: true,
	},
	toggleModals: {
		type: Function,
		required: true,
	},
});
const currentPassword = ref("");
const newPassword = ref("");
const verifyPassword = ref("");
const errorMessage = ref("");

// a computed prop
const passwordFieldMatches = computed(() => {
	return currentPassword.value && newPassword.value === verifyPassword.value && newPassword.value.length >= 8
})

async function updatePassword() {
	errorMessage.value = ""; // Clear previous errors
	try {
		const response = await fetch("/api/auth/changepassword", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				currentPassword: currentPassword.value,
				newPassword: newPassword.value,
				verifyPassword: verifyPassword.value,
			}),
		});

		const data = await response.json();
		console.log(response);

		if (!response.ok) {
			throw new Error(data.error || "something went wrong");
		}

		console.log("password updated:", data);

		currentPassword.value = "";
		newPassword.value = "";
		verifyPassword.value = "";

		props.passwordUpdated(data);
	} catch (error) {
		errorMessage.value = error.message;
		console.error("error message:", error);
	}
}

function onDialogMouseDown(event) {
	// Check if click is on the dialog backdrop (not inside the modal content)
	if (event.target === event.currentTarget) {
		closeModal();
	}
}

function closeModal() {
	const dialog = document.getElementById("update-password");
	dialog.close();
	dialog.setAttribute('data-open', false);
	props.toggleModals()
}
</script>

<template>
<dialog
	id="update-password"
	@mousedown="onDialogMouseDown"
	:data-open="props.isUpdatePasswordModalOpen"
>
	<div>
		<h2>Update Password</h2>
		<form @submit.prevent="updatePassword()" method="dialog">
			<p class="error" v-if="errorMessage">{{ errorMessage }}</p>
			<label>Current Password</label>
			<input v-model="currentPassword" type="password" placeholder="Current Password" aria-describedby="current-password" autocomplete="current-password" />
			<label>New Password</label>
			<input v-model="newPassword" type="password" placeholder="New Password" aria-describedby="new-password" autocomplete="new-password" />
			<label>Confirm Password</label>
			<input v-model="verifyPassword" type="password" placeholder="Confirm New Password" aria-describedby="verify-password" autocomplete="new-password" />
			<button class="btn primary wide" :disabled="!passwordFieldMatches">Update Password</button>
			<a @click="closeModal()" class="btn secondary wide">Cancel</a>
		</form>
	</div>
</dialog>
</template>

<style lang="scss" scoped>
#update-password {
	background-color: var(--bg1);
	border: none;
	box-sizing: border-box;
	color: var(--text1);
	padding: 0;
	position: fixed;
	inset: 0;
	margin: 0;
	width: 100vw;
	height: auto;
	max-width: 100vw;
	max-height: unset;
}
@media(min-width: 768px) and (min-height: 480px) {
	#update-password {
		border: 1px solid var(--border);
		border-radius: 24px;
		box-shadow: 0 30px 200px 40px rgba(0, 0, 0, 0.15), 0 30px 50px -30px rgba(0, 0, 0, 0.4), 0 30px 80px -50px rgba(0, 0, 0, 0.5);
		inset: calc(50vh - 225px) 0; // fallback
		inset: calc(50dvh - 225px) 0;
		margin: auto;
		height: unset;
		width: 400px;
		max-width: 100vw;
		max-height: 100vh; // fallback
		max-height: 100dvh;
	}
}
#update-password div {
	padding: 16px;
}
#update-password p { margin: .5rem 0; }
#update-password label {
	margin: 1rem 0 .5rem;
	display: block;
}
#update-password input { margin-bottom: 1rem; }
</style>
